// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Axios from 'axios'
import apiBaseUrlConfig from './global/apiBaseUrlConfig'
// 引入elementUI
import ElementUI from 'element-ui'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import utils from './global/utils'
import './global/directive';
import './global/rem';

import DatePicker from './components/common/el/date-picker'
import ArtThousandsInput from './components/common/el/art-thousands-input'

Vue.component(DatePicker.name, DatePicker)
Vue.component(ArtThousandsInput.name, ArtThousandsInput)


// 引入lodash 工具库
import _ from 'lodash'
Vue.prototype._ = _

import {i18n, loadLanguageAsync} from './lang/i18n-setup'
import echarts from 'echarts'
import VueAnimateNumber from 'vue-animate-number'
import Moment from 'moment'
import VueTouch from 'vue-touch'

// 引入总线
import Bus from './global/bus' // 引入组件

// 引入自写公共组件
Vue.use(apiBaseUrlConfig)
Vue.use(ElementUI)
Vue.use(Bus)
Vue.use(Viewer)
Vue.use(VueAnimateNumber)
Vue.use(VueTouch)

// 全局设定语言
const language = localStorage.getItem('art-i18n_language')
Moment.locale(language === 'zh-cn' ? 'zh-CN' : 'en-US')

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$utils = utils
Vue.prototype.loadLanguageAsync = loadLanguageAsync
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = Moment

Axios.defaults.baseURL = '/api'

/* eslint-disable */
let vue = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {App},
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js